import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ClientsService } from "app/clients/clients.service";

import { SlimScrollOptions } from "app/shared/shared.module";

@Component({
    selector: 'app-client-detail-inventory',
    templateUrl: './client-detail-inventory.component.html',
    styleUrls: ['./client-detail-inventory.component.css']
})
export class ClientDetailInventoryComponent implements OnInit {

    SlimScrollOptions = SlimScrollOptions;

    MedInvFilter: string;

    MedInv: Array<any>;

    constructor(private clientService: ClientsService, private activatedRoute: ActivatedRoute) {
        
    };

    ngOnInit() {
    };
}



// WEBPACK FOOTER //
// ./src/app/clients/details/inventory/client-detail-inventory.component.ts